export const DefaultErrorMessages = {
    required: "* required",
    lengthDigits: (length: number, field?: string) => `${field ?? "This field"} must be ${length} digits`,
    numeric: (field?: string) => `${field ?? "This field"} must be numeric`
};
